import {
 DestroyRef,
 Inject,
 Injectable,
 PLATFORM_ID,
 WritableSignal,
 effect,
 inject,
 signal,
} from '@angular/core';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { ModalService } from './modal.service';
import { LoadingModalComponent } from '@shared/components/loading-modal/loading-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription, filter, iif, interval, map, of, tap } from 'rxjs';
import { PlpRefreshAlertComponent } from '../../pages/search-result/components/plp-refresh-alert/plp-refresh-alert.component';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UtmService } from '@core/services/utm.service';
import { count } from 'console';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
 providedIn: 'root',
})
export class LoadingService {
 constructor(private modalService: ModalService, @Inject(PLATFORM_ID) private platformId: Object) {}

 isInterceptorActive: WritableSignal<boolean> = signal(false);
 loadingState: WritableSignal<boolean> = signal(false);
 navigationLoading: WritableSignal<boolean | number> = signal(0);
 dialog = inject(MatDialog);
 refreshModalTimer$: Observable<any> = interval(1000 * 60);
 modalTimerSub?: Subscription;
 loadingModalRef: any;
 route = inject(ActivatedRoute);
 utmService = inject(UtmService);
 destroyRef = inject(DestroyRef);

 showLoading() {
  this.modalService.showModal(LoadingComponent, {}, (result) => {});
  this.loadingState.update(() => true);
 }

 hideLoading() {
  // this.modalService.closeModal()
  this.loadingState.update(() => false);
 }

 resetRefreshModalTimer(pageType: string) {
  if (this.modalTimerSub) this.modalTimerSub.unsubscribe();

  this.modalTimerSub = this.refreshModalTimer$
   .pipe(
    takeUntilDestroyed(this.destroyRef),
    filter((count) => count === 14),
    tap((count) => {
     if (this.modalService.isAnyModalOpen()) return;
     if (!this.utmService.utmQueryString) this.showRefreshAlert(pageType);
    })
   )
   .subscribe(() => {});
 }

 showRefreshAlert(pageType: string, e?: Event) {
  e?.stopPropagation();

  const dialogRef = this.dialog.open(PlpRefreshAlertComponent, {
   data: {
    pageType: pageType,
   },
   panelClass: ['custom-modal', 'lg:rounded-md'],
   autoFocus: false,
   disableClose: true,
  });

  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {
    if (result === true) {
     dialogRef.close();
     window.location.reload();
     this.modalService.isAnyModalOpen.set(false);
    }
   });
 }

 showNavigation(navigationText: any) {
  this.loadingState.update(() => true);
  this.loadingModalRef = this.dialog.open(LoadingModalComponent, {
   panelClass: [
    'loading-modal',
    'lg:top-[30vh]',
    'top-[22vh]',
    'lg:left-[36vw]',
    'left-[0vw]',
    '!absolute',
    'w-screen',
    'lg:w-[460px]',
    'h-screen',
    '!max-w-full',
    'lg:h-[550px]',
    'p-4',
    'lg:p-0',
    '!flex',
    '!justify-center',
    '!items-center',
   ],
   disableClose: true,
   data: {
    navigationText: navigationText,
   },
   autoFocus: false,
   backdropClass: 'loadingModalBackdrop',
   // disableClose: false,
  });
 }

 hideNavigation() {
  this.loadingState.update(() => false);
   this.loadingModalRef?.close()
  // this.dialog.closeAll();
 }
 
}
